readDigits